import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation } from '@tanstack/react-query';

interface UseBillingBillRemoveCompanyRejectionProps {
  billId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: ErrorResponse) => void;
}

export const useBillingBillRemoveCompanyRejection = ({ billId, onSuccess, onError }: UseBillingBillRemoveCompanyRejectionProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingBillRemoveFailure', billId],
    mutationFn: () => privateAxios.put(`/billing/bills/${billId}/remove_company_rejection`),
    onSuccess,
    onError,
  });
};
